module.exports = __webpack_public_path__ + "img/profile-picture-joel-min.c1cd6198.png";